const clearingWidthSelector = [
  '.el-table > .el-table__header-wrapper > .el-table__header',
  '.el-table > .el-table__body-wrapper > .el-table__body',
  '.el-table > .el-table__body-wrapper > .el-table__empty-block',
].join(',');

/**
 * el-table を再レイアウトさせます
 *
 * @param el el-table を含む HTML 要素
 */
export function doLayoutElTable(el: HTMLElement) {
  const clearingWidthEls = el.querySelectorAll(clearingWidthSelector);
  for (const clearingWidthEl of clearingWidthEls) {
    (clearingWidthEl as HTMLElement).style.width = '';
  }
}
